import clsx from "clsx";
import { Children, cloneElement, useState } from "react";
import { twMerge } from "tailwind-merge";
import { v4 } from "uuid";

const HPTabs = ({ tabs = [], children }: any) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabContents = Children.toArray(children).reduce(
    (acc: any[], child: any, index) => {
      const content = Children.toArray(child?.props?.children).reduce(
        (acc, child: any) => {
          if (!acc.contents) acc.contents = [];

          if (child.props?.["data-highlight"]) {
            return { ...acc, banner: child };
          }

          if (child.props?.["data-info"]) {
            return { ...acc, info: child };
          }

          return {
            ...acc,
            contents: acc.contents.concat(child),
          };
        },
        { banner: null, info: null, contents: [] }
      );

      return acc.concat(content);
    },
    []
  );

  return (
    <div role="menu" className="flex flex-col w-full tabs">
      <div className="flex flex-row justify-center items-stretch gap-2 w-full">
        <ul className="bg-base-200 rounded-box w-56 menu">
          {tabs.map((tab: string, index: number) => (
            <li key={v4()} className={twMerge(clsx({ "mt-2": index > 0 }))}>
              <button
                key={`menu-item-${index}`}
                role="menuitem"
                className={twMerge(
                  clsx(
                    "bg-grape-light hover:bg-secondary hover:text-white menu",
                    {
                      "text-white": activeTab === index,
                      "bg-secondary": activeTab === index,
                    }
                  )
                )}
                onClick={() => setActiveTab(index)}
              >
                {tab}
              </button>
            </li>
          ))}
        </ul>
        <div className="flex-1 w-auto max-w-[540px]">
          <label className="block flex flex-col justify-items-start align-items-center bg-green-highlight bg-center py-3 pl-3 rounded-t-lg w-full text-left">
            {tabs[activeTab]}
          </label>
          {tabContents[activeTab]?.banner &&
            cloneElement(tabContents[activeTab]?.banner, {
              className: twMerge(
                clsx(
                  "flex flex-1 justify-center align-items-center bg-green-highlight -mt-2 rounded-lg w-full overflow-hidden",
                  tabContents[activeTab]?.banner.props.className
                )
              ),

              key: v4(),
            })}
        </div>
      </div>
      {tabContents[activeTab]?.info &&
        cloneElement(
          tabContents[activeTab]?.info,
          {
            className: twMerge(
              clsx(
                "relative flex-1 grid grid-cols-3 grid-rows-2 bg-green-highlight my-6 p-3 pt-5 rounded-lg",
                tabContents[activeTab]?.info.props.className
              )
            ),
            key: v4(),
          },
          [
            <label className="top-0 left-1/2 box-border absolute bg-green p-2 rounded-badge min-w-40 text-center text-sm uppercase -translate-x-1/2 -translate-y-1/2">
              {tabContents[activeTab]?.info.props["data-title"]}
            </label>,
            (tabContents[activeTab]?.info.props["data-image"] && (
              <div className="rounded-lg h-fit overflow-hidden">
                <img
                  className="w-full"
                  src={tabContents[activeTab]?.info.props["data-image"]}
                  alt={tabContents[activeTab]?.info.props["data-name"]}
                />
              </div>
            )) ||
              null,
            Children.toArray(tabContents[activeTab]?.info.props.children).map(
              (child: any) => {
                if (!child) return null;
                let childClassNames = "";
                if (child.props?.["data-content"] === "profile") {
                  childClassNames = "col-start-2 row-span-2";
                } else if (child.props?.["data-content"] === "prupose") {
                  childClassNames = "col-start-3 row-start-1";
                } else if (child.props?.["data-content"] === "key") {
                  childClassNames = "col-start-3 row-start-2";
                }

                return cloneElement(
                  child,
                  {
                    className: twMerge(
                      clsx("h-fit", childClassNames, child.props.className)
                    ),
                    key: v4(),
                  },
                  [
                    <h3 className="text-base text-left">
                      {child.props["data-title"]}
                    </h3>,
                    Children.toArray(child.props.children).map((c: any) => (
                      <div
                        key={v4()}
                        className="border-secondary border-l-4 border-solid text-base text-sm"
                      >
                        {c}
                      </div>
                    )),
                  ]
                );
              }
            ),
          ]
        )}

      <div className="py-6">
        {tabContents[activeTab]?.contents}
        {tabContents[activeTab].contents.map(
          (tabContent: any, index: number) => (
            <div
              key={v4()}
              className={twMerge(
                clsx(
                  "bg-purple-400 w-full text-justify align-middle tab-content"
                )
              )}
            >
              {tabContent}
              {/* {Children.toArray(tabContent.contents).map((c: any) => {
                
                return cloneElement(
                  c,
                  {
                    key: v4(),
                  },
                  c.props.children
                );
              })} */}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default HPTabs;
